import { createAction } from "redux-actions";
import {
  SET_CATEGORY_BREADCRUMBS,
  SET_CATEGORY_GENDER,
  SET_CATEGORY_SERVER_ERROR,
  SET_CATEGORY_CHILD_LINKS,
  SET_CATEGORY_IS_BRAND
} from "../constants";

export const setCategoryBreadcrumbs = createAction(SET_CATEGORY_BREADCRUMBS);

export const setCategoryGender = createAction(SET_CATEGORY_GENDER);

export const setCategoryServerError = createAction(SET_CATEGORY_SERVER_ERROR);

export const setCategoryChildLinks = createAction(SET_CATEGORY_CHILD_LINKS);

export const setCategoryIsBrand = createAction(SET_CATEGORY_IS_BRAND);
